import React from "react";
import { PieChart, Pie, Cell, Label } from "recharts";
import { Box, Typography } from "@mui/material";

interface DonutChartCardProps {
  title: string;
  data: { name: string; value: number }[]; // e.g. [{ name: "Active", value: 148 }, { name: "Inactive", value: 13 }]
  total: number;
  colors: string; // Active color (Inactive will be gray)
}

const DonutWidget: React.FC<DonutChartCardProps> = ({
  title,
  data,
  total,
  colors,
}) => {
  const ACTIVE_COLOR = colors || "#007BFF";
  const INACTIVE_COLOR = "#E5E5E5";

  const chartColors = [ACTIVE_COLOR, INACTIVE_COLOR];

  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#fff",
        borderRadius: "16px",
        p: 2,
        width: "100%",
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          color: "#017CC9",
          fontWeight: 600,
          fontSize: "15px",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      {/* Donut Chart */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <PieChart width={150} height={150}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={45}
            outerRadius={75}
            startAngle={90}
            endAngle={450}
            dataKey="value"
            paddingAngle={1}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={chartColors[index % chartColors.length]}
              />
            ))}
            <Label
              position="center"
              content={() => (
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                >
                  <tspan
                    x="50%"
                    dy="-6"
                    style={{ fontSize: "12px" }}
                    fill="#575757"
                  >
                    Total
                  </tspan>
                  <tspan
                    x="50%"
                    dy="18"
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      fill: "#575757",
                    }}
                  >
                    {total}
                  </tspan>
                </text>
              )}
            />
          </Pie>
        </PieChart>
      </Box>

      {/* Legend */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          mt: 1,
        }}
      >
        {/* Active */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: ACTIVE_COLOR,
            }}
          />
          <Typography sx={{ fontSize: 14, color: "#575757" }}>
            {data[0]?.name}: {data[0]?.value}
          </Typography>
        </Box>
<span>/</span>
        {/* Inactive */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography sx={{ fontSize: 14, color: "#575757" }}>
            {data[1]?.name}: {data[1]?.value}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DonutWidget;
